/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { AzureContainerRegistryFeedResource, FeedResource, AcrOidcFeedAuthentication } from "@octopusdeploy/octopus-server-client";
import { FeedType, isAcrOidc } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import ExternalLink from "~/components/Navigation/ExternalLink/ExternalLink";
import AdvancedFeedCredentialsFormSection, { AuthenticationType } from "../AdvancedFeedCredentialsFormSection";
import type { FeedEditProps } from "./feedTypeRegistry";
import feedTypeRegistry from "./feedTypeRegistry";
class AzureContainerRegistryFeed extends React.Component<FeedEditProps<AzureContainerRegistryFeedResource>> {
    render() {
        return (<React.Fragment>
                <AdvancedFeedCredentialsFormSection model={{ username: this.props.feed.Username, password: this.props.feed.Password }} isNew={!this.props.feed.Id} onChanged={(model, oidcModel) => (isAcrOidc(oidcModel) ? this.updateAuthentication({ OidcAuthentication: oidcModel }) : this.updateAuthentication({ Password: model.password, Username: model.username }))} containerKey={this.props.expandableContainerKey} oidcModel={this.props.feed.OidcAuthentication} supportedAuthenticationTypes={isFeatureToggleEnabled("ExternalOidcFeedsFeatureToggle") ? [AuthenticationType.UsernameAndPassword, AuthenticationType.Oidc] : [AuthenticationType.UsernameAndPassword]}/>
            </React.Fragment>);
    }
    private updateAuthentication = (updatedFields: Partial<AzureContainerRegistryFeedResource>) => {
        const existingAuthDetails = this.props.feed;
        const updatedOidcAuthentication: AcrOidcFeedAuthentication = {
            Audience: updatedFields.OidcAuthentication?.Audience ?? existingAuthDetails.OidcAuthentication?.Audience ?? "",
            SubjectKeys: updatedFields.OidcAuthentication?.SubjectKeys ?? existingAuthDetails.OidcAuthentication?.SubjectKeys ?? [],
            ClientId: updatedFields.OidcAuthentication?.ClientId ?? existingAuthDetails.OidcAuthentication?.ClientId ?? "",
            TenantId: updatedFields.OidcAuthentication?.TenantId ?? existingAuthDetails.OidcAuthentication?.TenantId ?? "",
        };
        this.props.onChange({ ...this.props.feed, Password: updatedFields.Password, Username: updatedFields.Username, OidcAuthentication: updatedOidcAuthentication });
    };
    static displayName = "AzureContainerRegistryFeed";
}
feedTypeRegistry.registerFeedType({
    type: FeedType.AzureContainerRegistry,
    edit: AzureContainerRegistryFeed as React.ComponentType<FeedEditProps<FeedResource>>,
    text: "Azure Container Registry",
    uriNotes: (<React.Fragment>
            <div>
                See Azure Container Registry <ExternalLink href="ACRRegistryLinks">documentation</ExternalLink>.
                <br />
                Configure an <ExternalLink href="U3Ak1K">Azure Contaner Registry</ExternalLink> in Octopus.
            </div>
        </React.Fragment>),
    uriDefault: "https://{myoctoregistry-on}.azurecr.io",
});
